import type { ReactNode } from "react";
import { cn } from "@core/utils";

interface SettingsSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

/**
 * One block of a settings page: the section name in a left column, its fields in the right one,
 * a divider above (Figma: Général / Places / Programme on the cohort settings; Profil /
 * Sécurité / Langue on « Mon compte »). Stacks below `lg`, name over fields.
 *
 * Stack several of them in a column: each draws its own top divider, so the first one closes the
 * header and the last needs no closing line.
 */
export function SettingsSection({
  title,
  children,
  className,
}: SettingsSectionProps) {
  return (
    <section
      className={cn(
        "grid gap-md border-t border-(--border-default) py-xl",
        "lg:grid-cols-[11rem_minmax(0,36rem)] lg:gap-2xl",
        className
      )}
    >
      <h2 className="text-md-semibold text-(--text-primary)">{title}</h2>
      <div className="flex min-w-0 flex-col gap-md">{children}</div>
    </section>
  );
}

export type { SettingsSectionProps };
